import s from '../allservices.jsx'

export const transferHistory = (actionCallback, id, startDate, endDate, status) => {
    let token = "Token " + localStorage.getItem('token')
    const state = {
        applicationId: "gmcabs",
        cardDetailsId: id,
        historyType: "P",
        statementFromDate: startDate || "",
        statementTodDate: endDate || "",
        status: status
    }
    fetch(s.get_transactionid, {
        method: "POST",
        headers: {
            'content-type': 'application/json',
            'Authorization': token
        },
        body: JSON.stringify(state)
    })
        .then(res => {
            if (res.status === 200 || res.status === 201) {
                res.json().then(json => actionCallback(json, "success", res.status))
            } else if (res.status === 204) {
                actionCallback({ "transactions": [] }, "success", res.status)
            } else {
                actionCallback([], res.headers.get('message'), res.status)
            }
        })
}


// WEBPACK FOOTER //
// ./src/services/components/transfer_history.jsx